import { Storage } from "@ionic/storage";

export interface SocketConfigs {
    transports: Array<"websocket" | string>;
    reconnectionDelay?: number;
    reconnectionDelayMax?: number;
}

const sessionIdCookieKeyLocalStorage = "sessionIdCookie";

function getSocketConfigs(
    type: "notifications" | "chat",
    cookie?: string
): [SocketConfigs, string] {
    const queryParams = JSON.parse(JSON.stringify({ chatSocketAPIVersion: 3, cookie: cookie }));

    const params = new URLSearchParams(queryParams);
    const token = window.localStorage.getItem("token");
    const serverUrl = process.env.REACT_APP_API_URL;
    if (token) {
        params.append("authorization", `Bearer ${token}`);
    }
    const url = `${serverUrl}/v1/${type}?${params}`;
    let initSocketConfig = {
        transports: ["websocket"],
        reconnectionDelay: 2000,
        reconnectionDelayMax: 20000,
    };
    return [initSocketConfig, url];
}

export function parseCookiesGetSessionIdCookie(allCookies: string): string | undefined {
    const splitted = allCookies.split(";").map((c) => c.trim());
    return splitted.find((cookie) => cookie.includes("sessionid"));
}

const store = new Storage();
store.create();

export function setSessionIdCookieLocalStorage(cookie: string) {
    store.set(sessionIdCookieKeyLocalStorage, cookie);
}

export async function getSessionIdCookieLocalStorage(): Promise<string> {
    return await store.get(sessionIdCookieKeyLocalStorage);
}
export { getSocketConfigs };
